$(function () {
  initCustomBCSF();
});

/**
 * Functions to extend the BC search and filter app, without
 * modifying the source code too much.
 */
function initCustomBCSF() {
  let firstLoad = true;
  let allCollectionProducts = [];

  var isSafari = navigator.vendor && navigator.vendor.indexOf('Apple') > -1 &&
    navigator.userAgent &&
    navigator.userAgent.indexOf('CriOS') == -1 &&
    navigator.userAgent.indexOf('FxiOS') == -1;

  function runMarketingTileForItem(item) {
    let el = $(item);
    let handle = el.attr('data-handle');

    // Skips already processed tiles
    if (el.hasClass('marketingTile')) {
      return;
    }

    const tileMetafields = (window.collectionMarketingMetafields || {})[handle];
    if(tileMetafields) {
      el.addClass('marketingTile');
      $('.bc-sf-filter-product-item-label', el).hide();
      $('.bc-sf-filter-product-bottom', el).hide();
      $('.itemFlair', el).hide();
      $('button', el).hide();
      $('a', el).attr('href', tileMetafields.marketing_tile_link);
    }

    if (document.body.classList.contains('is-b2b')) {
      const boostSearchObserver = new MutationObserver(
        (callback, observer) => callback.forEach((mutation) => {
          mutation.addedNodes.forEach(
            ($group) => {
              if (!$group.classList) {
                return;
              }

              if (!$group.classList.contains('bc-sf-search-suggestion-group')) {
                return;
              }

              if ($group.getAttribute('data-group') != 'products') {
                return;
              }

              runSearchPriceFix($group);
            }
          );
        })
      );

      boostSearchObserver.observe(document.body, { childList: true, subtree: true });
    }
  }

  function runMarketingTile() {
    $('.bc-sf-filter-product-item').each((i, o) => runMarketingTileForItem(o));
  }

  // Runs the marketing tile routing right after a new item has been added
  document.addEventListener('custom:boost-new-item', event => {
    runMarketingTileForItem(event.detail.item);
    runCollectionPriceFix();
  });

  function runColorCountFix(ajax=false) {
    //localStorage.setItem("allCollectionProducts", '{}');
    let allProducts = JSON.parse(localStorage.getItem("allCollectionProducts"));
    let collectionHandle = $('.section-collection').attr('data-collection-handle');
    if( !isSafari && allProducts != null && Object.keys(allProducts).length > 0 ) {

      let timestampNow = Math.floor(Date.now() / 1000);
      let localStorageTimestamp = localStorage.getItem("allCollectionProductsTimestamp");
      if( (timestampNow - parseInt(localStorageTimestamp)) > 300 ) {
        if(typeof collectionHandle != "undefined") {
          fixAllColorCounts(collectionHandle);
        }
        else {
          fixAllColorCounts('sample-dresses');
          fixAllColorCounts('junior-at-home-try-on');
          fixAllColorCounts('maternity-at-home-try-on');
          fixAllColorCounts('wedding-dresses-at-home-try-on');
        }
      }
      else {
        firstLoad = false;
        if(!ajax) {
          $(window).on('load', function() {
            fixColorsCount(allProducts);
          });
        }
        else {
          fixColorsCount(allProducts);
        }
      }
    }
    else {
      if(typeof collectionHandle != "undefined") {
        fixAllColorCounts(collectionHandle);
      }
      else {
        fixAllColorCounts('sample-dresses');
        fixAllColorCounts('junior-at-home-try-on');
        fixAllColorCounts('maternity-at-home-try-on');
        fixAllColorCounts('wedding-dresses-at-home-try-on');
      }
    }
  }

  runColorCountFix();

  $(document).on('ajaxComplete',function(e){
    if(
      typeof e.currentTarget.URL != "undefined" &&
      e.currentTarget.URL.indexOf('/collections/') > -1 &&
      e.currentTarget.URL.indexOf('products.json') < 0
    ) {
      if (!firstLoad) {
        setTimeout(() =>{
          runColorCountFix(true);
        }, 100);
      }
    }
  });

  /**
   * Recursively build an array of all products
   * in the given collection and fix swatches after it's done.
   *
   * @param handle
   * @param page
   * @param overwrite
   */
  async function getAllCollectionProducts(handle = null, page = 1) {
    function getCollectionPage(handle, page) {
      return new Promise((resolve) => {
        $.ajax({
          url: `/collections/${handle}/products.json?limit=250&page=${page}`,
          dataType: 'json',
          success: (json) => resolve(json || null),
          error: (err) => resolve(null),
        });
      });
    }

    const products = [];
    do {
      const json = await getCollectionPage(handle, page);

      if (!json?.products || json.products.length < 1) {
        break;
      }

      products.push(...json.products);

      if (json.products.length >= 250) {
        page++;
      } else {
        break;
      }
    } while (true);

    return products;
  }

  function runCollectionPriceFix() {
    if (!document.body.classList.contains('is-b2b')) {
      return;
    }

    if (runCollectionPriceFix.debounce) {
      return;
    }

    runCollectionPriceFix.debounce = true;
    setTimeout(async () => {
      delete runCollectionPriceFix.debounce;

      if (!window.CollectionAllProducts) {
        window.CollectionAllProducts = await getAllCollectionProducts(
          $('.section-collection').attr('data-collection-handle')
        );
      }

      const productPrices = {};
      for (const product of window.CollectionAllProducts) {
        let price_min = Infinity, price_max = -Infinity;

        for (const variant of product.variants) {
          price_min = Math.min(price_min, parseInt(variant.price.replace('.', '')));
          price_max = Math.max(price_max, parseInt(variant.price.replace('.', '')));
        }

        productPrices[product.id] = {
          price_min: price_min,
          price_max: price_max,
        };
      }

      for (const $item of document.querySelectorAll('.bc-sf-filter-product-item')) {
        const productId = $item.getAttribute('boost-item');
        const prices = productPrices[productId];

        if (!productId || !prices) {
          continue;
        }

        const $startingAt = $item.querySelector('.starting-at');
        const $startingPrice = $item.querySelector('.starting-price');
        if ($startingAt) {
          $startingAt.nextSibling.textContent = `$ ${(prices.price_min / 100).toFixed(2)}`;
          $startingAt.parentElement.classList.add('bc-sf-filter-product-item-regular-price');
          $startingAt.parentElement.classList.remove('bc-sf-filter-product-item-sale-price');
          $startingAt.parentElement.parentElement.querySelector('s')?.remove();
        } else if($startingPrice) {
          $startingPrice.textContent = `$ ${(prices.price_min / 100).toFixed(2)}`;
          $startingPrice.parentElement.classList.add('bc-sf-filter-product-item-regular-price');
          $startingPrice.parentElement.classList.remove('bc-sf-filter-product-item-sale-price');
          $startingPrice.parentElement.parentElement.querySelector('s')?.remove();
        }
      }
    }, 100);
  }

  function runSearchPriceFix($group) {
    window.SearchProductsCache = window.SearchProductsCache || {};

    if (runSearchPriceFix.debounce) {
      return;
    }
    runSearchPriceFix.debounce = true;

    setTimeout(async () => {
      delete runSearchPriceFix.debounce;
      
      for (const $item of $group.querySelectorAll('.bc-sf-search-suggestion-item')) {
        const product_id = $item.getAttribute('data-label');
        const product_url = $item.querySelector('a[href]')?.href;
        const $product_price = $item.querySelector('.bc-sf-search-suggestion-product-price');

        if ($product_price) {
          function updatePrice(product) {
            $product_price.textContent = `$${product.variants[0].price}`;
          }

          if (window.SearchProductsCache[product_id]) {
            updatePrice(window.SearchProductsCache[product_id]);
            continue;
          }

          fetch(`${product_url}.json`)
            .then((response) => response.json())
            .then(({ product }) => {
              window.SearchProductsCache[product_id] = product;
              updatePrice(product);
            });
        }
      }
    });
  }

  /**
   * Fixes all color counts on the collection
   *
   * @param handle
   * @param page
   * @param overwrite
   */
  function fixAllColorCounts(handle=null, page=1, overwrite=false) {
    if(!handle) return;

    getAllCollectionProducts(handle, page)
      .then((products) => {
        fixColorsCount(products, true, overwrite);
      });
  }

  function fixColorsCount(allProducts, map=false, overwrite=false) {
    setTimeout(function(){
      let objects = {};
      // Map array so it becomes an object with handles as keys
      if( map ) {
        objects = mapProductsForColorCount(allProducts, overwrite);
      }
      else {
        objects = allProducts;
      }

      if(
        !(objects && Object.keys(objects).length === 0 && objects.constructor === Object)
      ) {
        // Start fixing the products
        $('.bc-sf-filter-product-item').each(function() {
          let el = $(this);
          let handle = el.attr('data-handle');
          let soldOutBadge = el.find('.bc-sf-filter-label.soldout');
          let colorCount = el.find('.list-colors li:last-child p');

          let targetObject = objects[handle];

          if(typeof targetObject != "undefined" && targetObject.hasOwnProperty('colorsCount')) {
            let strEnd = targetObject.colorsCount > 1 ? 's' : '';

            colorCount.html(targetObject.colorsCount + ' Color' + strEnd);
            soldOutBadge.addClass('hidden');
          }
          else {
            soldOutBadge.removeClass('hidden');
          }
        });
      }

    },10);
  }

  /**
   * This function links child sample products to their parents,
   * counts the available variants and adds a "colorsCount" parameter to the parent.
   *
   * @param allProducts
   * @param overwrite
   * @returns {*|{}}
   */
  function mapProductsForColorCount(allProducts, overwrite=false) {
    let objects = {};
    let newObjects = [];

    // Shrink data size by only saving what we need
    allProducts.forEach(function(prod) {
      let variants = [];
      prod.variants.forEach(function(variant) {
        let dataVar = {
          id: variant.id,
          title: variant.title,
          option1: variant.option1,
          option2: variant.option2,
          option3: variant.option3,
          available: variant.available,
        };
        variants.push(dataVar);
      });

      let data = {
        id: prod.id,
        handle: prod.handle,
        variants: variants,
      };
      newObjects.push(data)
    })

    // Turn the array into an object and use the product handle as the key
    let mapped = (arr, key) => arr.reduce((a, b) => ({ ...a, [b[key]]: b }), {});
    objects = mapped(newObjects,'handle');

    // Link child products that have different handles than parents
    objects = parseMetafieldColorCount(objects);

    // Get sizes products inside the parent product object
    for (let handle in objects) {
      if(!objects.hasOwnProperty(handle)) continue;
      let obj = objects[handle];
      if( obj.handle.indexOf('-size-') > -1 ) {
        let parentHandle = obj.handle.split('-size-')[0];

        if(objects.hasOwnProperty(parentHandle)) {
          if( typeof objects[parentHandle].sizes == "undefined" ) objects[parentHandle].sizes = [];
          objects[parentHandle].sizes.push(obj);
          delete objects[obj.handle];
        }
      }
    }

    // Get the available colors count for products not in the metafield
    for (let handle in objects) {
      if(!objects.hasOwnProperty(handle)) continue;
      let obj = objects[handle];

      if(obj.hasOwnProperty('sizes')) {
        let availableColors = {};
        obj.sizes.forEach(function(sizeObj) {
          sizeObj.variants.forEach(function(variantObj) {
            let title = variantObj.title.replace('"','');
            if( variantObj.available ) availableColors[title] = 1;
          })
        });

        objects[handle].colorsCount = Object.keys(availableColors).length;
      }
    }

    if(!overwrite) {
      let existing = localStorage.getItem("allCollectionProducts");
      if(existing != null) objects = Object.assign(JSON.parse(existing), objects);
    }

    // Try to save to local storage.
    // If there are too many products/variants it will fail and the products
    // will be fetched via ajax again on the next page load.
    if(!isSafari) {
      try {
        localStorage.setItem("allCollectionProducts", JSON.stringify(objects));
        localStorage.setItem("allCollectionProductsTimestamp", Math.floor(Date.now() / 1000).toString());
        firstLoad = false;
      }
      catch (e) {
        console.error("Local Storage is full, Please empty data", e);
      }
    }
    return objects;
  }

  /**
   * Some child products have different handle bases (handle without the size part) than
   * their parent products and are missed/skipped in the default mapping.
   * This function links those child products to their proper parents.
   *
   * @param objects
   * @returns {*}
   */
  function parseMetafieldColorCount(objects) {
    let metafieldProducts = $('#bc-sf-filter-wrapper').attr('data-color_count_products');
    metafieldProducts = JSON.parse(metafieldProducts);

    for (let parentHandle in metafieldProducts) {
      if(!metafieldProducts.hasOwnProperty(parentHandle)) continue;
      let children = metafieldProducts[parentHandle];

      for (let sizeHandle in children) {
        if(!children.hasOwnProperty(sizeHandle)) continue;
        let childHandle = children[sizeHandle];

        if(objects.hasOwnProperty(childHandle)) {
          if( typeof objects[parentHandle].sizes == "undefined" ) objects[parentHandle].sizes = [];
          objects[parentHandle].sizes.push(objects[childHandle]);
          delete objects[childHandle];
        }
      }
    }

    return objects;

  }
}